import axios from 'axios';
import connection from './connection';
import { RmToleranceResponse, RmToleranceDto, AllRmToleranceResponse} from '@gtpl/shared-models/raw-material-procurement';


export class RmToleranceService {

    URL = connection.DEPLOY_URL + '/rm-tolerance';


    async create(dto: RmToleranceDto): Promise<RmToleranceResponse> {
        return await axios.post(this.URL + '/createRmTolerance', dto)
            .then(res => {
                return res.data
            })
    }


    async update(dto: RmToleranceDto): Promise<RmToleranceResponse> {
        return await axios.post(this.URL + '/updateRmTolerance', dto)
            .then(res => {
                return res.data
            })
    }


    async activatedeActivate(Dto: RmToleranceDto): Promise<RmToleranceResponse> {
        return await axios.post(this.URL + '/activateOrDeactivateRmTolerance', Dto)
            .then(res => {
                return res.data
            })
    }



    async getAll(): Promise<AllRmToleranceResponse> {
        return await axios.post(this.URL + '/getAllRmTolerance')
            .then(res => {
                return res.data
            })
    }

}